/**
 * use_ags を持つアプリケーションのリストをフィルタリングする
 *
 * @param applications
 * @returns
 */
export const findApplicationAgs = (applications: any): any[] => {
    if (!applications) return [];

    const applicationsClone: any[] = [...applications];
    return applicationsClone?.filter((application: any) => application?.use_ags) ?? [];
};

/**
 * 最新の score_line_item を持つ take を検索する
 * 
 * @param application 
 * @returns 
 */
export const findTakeHasNewScoreLineItem = (application: any) => {
    return (
        application?.takes?.find((take: any) =>
            take.line_items.find(
                (lineItem: any) =>
                    lineItem?.score_line_items && lineItem.score_line_items.length > 0,
            ),
        ) ?? null
    );
};
